<sim-basic-material-dialog
	(closeClicked)="close()"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-simle'}"
	[headerText]="T.RATING_ITEM_ICON_SET_CONFIGURATION_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-rating-item-icon-set-form
			[iconDefinitions]="ratingItemIconSet().icons"
			(onIconDefinitionsChange)="setIconDefinitions($event)"
		/>
	</ng-container>

	<ng-container actions>
		<sim-button
			(onClick)="close()"
			[color]="'warn'"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CLOSE | translate"
		/>

		<sim-button (onClick)="ok()" [color]="'accent'" [icon]="{fontSet: 'fad', fontIcon: 'fa-check'}" [label]="T.BUTTON_OK | translate" />
	</ng-container>
</sim-basic-material-dialog>
